'use strict';

var markdownLineEnding = require('../character/markdown-line-ending.js');

var factorySpace = require('./factory-space.js');

var partialBlankLine = {
  tokenize: tokenizePartialBlankLine,
  partial: true
};

function tokenizePartialBlankLine(effects, ok, nok) {
  return factorySpace(effects, afterWhitespace, 'linePrefix');

  function afterWhitespace(code) {
    return code === null || markdownLineEnding(code) ? ok(code) : nok(code);
  }
}

module.exports = partialBlankLine;